export const upload = () => {
  // let url = "/api/clothingAnnouncement/upload";

  let url = "https://nyesgc.cn/clothingweb/clothingAnnouncement/upload"

  return url;
};
